import { avatar } from "@material-tailwind/react"
import {
    LeafletDriverOfflineIconNew,
    LeafletDriverOnlineFreeIconNew,
    LeafletDriverOnlineBusyIconNew,
    LeafletDriverOnlineFreeIconNewFocused,
    LeafletDriverOnlineBusyIconNewFocused,
    LeafletDriverOfflineIconNewFocused,
    LeafletDriverAnalyticsFreeIconNew,
    LeafletDriverAnalyticsBusyIconNew,
    LeafletDriverAnalyticsFreeIconNewFocused,
    LeafletDriverAnalyticsBusyIconNewFocused
} from "../../../components/common/leaflet-icons"

export const getDriverIcon = (driver, selectedDriverId) => {
    // Safely generate fullName and avatar URL
    const fullName = (driver?.firstName || "") + " " + (driver?.lastName || "");
    const avatarUrl = driver?.avatarUrl || "";

    // Utility function to generate icon instances
    const createIcons = function (factory) {
        return factory(avatarUrl, fullName);
    };

    // Create driver icons
    const vLeafletDriverOfflineIconNewFocused = createIcons(LeafletDriverOfflineIconNewFocused);
    const vLeafletDriverOfflineIconNew = createIcons(LeafletDriverOfflineIconNew);

    const vLeafletDriverAnalyticsFreeIconNewFocused = createIcons(LeafletDriverAnalyticsFreeIconNewFocused);
    const vLeafletDriverAnalyticsFreeIconNew = createIcons(LeafletDriverAnalyticsFreeIconNew);

    const vLeafletDriverAnalyticsBusyIconNewFocused = createIcons(LeafletDriverAnalyticsBusyIconNewFocused);
    const vLeafletDriverAnalyticsBusyIconNew = createIcons(LeafletDriverAnalyticsBusyIconNew);

    const vLeafletDriverOnlineFreeIconNewFocused = createIcons(LeafletDriverOnlineFreeIconNewFocused);
    const vLeafletDriverOnlineFreeIconNew = createIcons(LeafletDriverOnlineFreeIconNew);

    const vLeafletDriverOnlineBusyIconNewFocused = createIcons(LeafletDriverOnlineBusyIconNewFocused);
    const vLeafletDriverOnlineBusyIconNew = createIcons(LeafletDriverOnlineBusyIconNew);

    let driverMarker = selectedDriverId === driver?.id
        ? vLeafletDriverOfflineIconNewFocused
        : vLeafletDriverOfflineIconNew

    if (driver.imei) {
        if (driver.isOnline && !driver.isBusy) {
            driverMarker = selectedDriverId === driver?.id
                ? vLeafletDriverAnalyticsFreeIconNewFocused
                : vLeafletDriverAnalyticsFreeIconNew
        } else if (driver.isOnline && driver.isBusy) {
            driverMarker = selectedDriverId === driver?.id
                ? vLeafletDriverAnalyticsBusyIconNewFocused
                : vLeafletDriverAnalyticsBusyIconNew
        }
    }
    else {

        if (driver.isOnline && !driver.isBusy) {
            // driver is online & free
            driverMarker = selectedDriverId === driver?.id
                ? vLeafletDriverOnlineFreeIconNewFocused
                : vLeafletDriverOnlineFreeIconNew
        } else if (driver.isOnline && driver.isBusy) {
            // driver is online & busy
            driverMarker = selectedDriverId === driver?.id
                ? vLeafletDriverOnlineBusyIconNewFocused
                : vLeafletDriverOnlineBusyIconNew
        }
    }

    // if selected
    if (parseInt(driver.id) === parseInt(selectedDriverId)) {
        driverMarker = vLeafletDriverOfflineIconNewFocused
        if (driver.isOnline && !driver.isBusy) {
            // driver is online & free
            driverMarker = vLeafletDriverOnlineFreeIconNewFocused
        } else if (driver.isOnline && driver.isBusy) {
            // driver is online & busy
            driverMarker = vLeafletDriverOnlineBusyIconNewFocused
        }
    }

    return driverMarker
}